import api, { API_BASE_URL } from './api';

export const authService = {
  sendRegistrationOtp: async (userData) => {
    return api.post('/send-registration-otp', userData);
  },

  login: async (credentials) => {
    const response = await api.post('/login', credentials);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('refresh_token');
  },

  verifyEmail: async (data) => {
    return api.post('/verify-email', data);
  },

  resendEmailCode: async (data) => {
    return api.post('/resend-email-code', data);
  },

  verifyPhone: async (data) => {
    const response = await api.post('/verify-phone', data);
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  resendPhoneCode: async (data) => {
    return api.post('/resend-phone-code', data);
  },

  getCurrentUser: async () => {
    return api.get('/user');
  },

  updateProfile: async (data) => {
    const response = await api.put('/user', data);
    if (response.data.user) {
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },

  getStoredUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  requestPasswordReset: async (data) => {
    return api.post('/forgot-password', data);
  },

  verifyResetCode: async (data) => {
    return api.post('/verify-reset-code', data);
  },

  resetPassword: async (data) => {
    return api.post('/reset-password', data);
  },

  updatePassword: async (data) => {
    return api.put('/user/password', data);
  },
};

export default authService;
